import CONFIG from '~config/env'
import RestApi from '~services/restApi'
import { v4 as uuid } from 'uuid'

export default {
  data() {
    return {
      MIME_TYPES: {
        PDF: 'application/pdf',
        TXT: 'text/plain',
        CSV: 'text/csv',
        XML: 'text/xml'
      }
    }
  },
  methods: {
    download(mimeType, filename, text, customName) {
      const linkElement = document.createElement('a')
      linkElement.style.display = 'none'
      linkElement.setAttribute('target', '_blank')

      if (text && (mimeType === this.MIME_TYPES.TXT || mimeType === this.MIME_TYPES.CSV || mimeType === this.MIME_TYPES.XML)) {
        linkElement.href = 'data:' + mimeType + ';charset=utf-8,' + encodeURIComponent(text)
        linkElement.download = filename
      } else {
        linkElement.href = filename
        const name = filename.substring(filename.lastIndexOf('/') + 1, filename.length)
        linkElement.download = customName || name
      }

      document.body.appendChild(linkElement)
      linkElement.click()
      document.body.removeChild(linkElement)
    },
    async getSignedS3Url(file, customName) {
      if (!file?.url) {
        this.$toasted.error('URL Inválida')
        return
      }

      const key = file.url.replace(CONFIG.AWS.S3_PUBLIC_URL + '/', '').replace(CONFIG.AWS.S3_PRIVATE_URL + '/', '')
      const signedUrl = await RestApi.getAwsSignedUrl(key, customName || file.name)
      return signedUrl.data
    },
    async getMultipleSignedS3Url(files) {
      if (!files?.length) {
        this.$toasted.error('Nenhum arquivo selecionado')
        return
      }

      const filesKeys = files
        .map(file => {
          return file.key
        })
        .join(',')

      const filesCustomNames = files
        .map(file => {
          return file.customName
        })
        .join(',')

      const signedUrl = await RestApi.getAwsMultipleSignedUrl(filesKeys, filesCustomNames)
      return signedUrl.data
    },
    async getSignedZapSignUrl(file, useSignedFile) {
      if (!file?.url) {
        this.$toasted.error('URL Inválida')
        return
      }

      if (!file?.signatureToken) {
        this.$toasted.error('Token de assinatura inválido')
        return
      }

      const token = file.signatureToken
      const { data: signedUrls } = await RestApi.getSignedDocumentsUrl(token)

      if (!signedUrls.signed_file && !signedUrls.original_file) {
        this.$toasted.error('Erro ao encontrar o arquivo no servidor')
        return
      }

      if (useSignedFile) {
        return signedUrls.signed_file
      } else if (file.url) {
        return signedUrls.original_file
      }
    },
    async downloadFileFromS3(file, customName) {
      const formattedName = String(customName || file.name).replace(/ /g, '+')
      const url = await this.getSignedS3Url(file, formattedName)
      this.download('', url, undefined, formattedName)
    },
    async downloadFileFromZapSign(file, useSignedFile, customName) {
      const url = await this.getSignedZapSignUrl(file, useSignedFile)
      this.download('', url, undefined, customName || file.name)
    },
    getFullUrl(url) {
      const baseReportURL = 'https://app.regularizei.app.br'
      return baseReportURL + url + '?token=' + this.$authToken
    },
    async getJobToGenerateLandMainDocument(land, landDocuments, jobBatchId) {
      const documentTypes = this.$store.state.documentsModule.documentTypes

      const docTypeLandDossie = documentTypes.find(({ slug }) => slug === 'land-main-document')

      if (!docTypeLandDossie) {
        this.$toasted.error('Não foi possível encontrar o tipo de documento "Dossiê do Lote"')
        return
      }
      if (!docTypeLandDossie) {
        this.$toasted.error('Não foi possível encontrar o tipo de documento "Dossiê do Lote"')
        return
      }

      const documentTypeSlugOrder = [
        { slug: 'zapsign-uniao-estavel', pages: [0, 1, -2, -1] },
        { slug: 'zapsign-casados', pages: [0, 1, -2, -1] },
        { slug: 'zapsign-outros', pages: [0, 1, 7] },
        { slug: 'procuracao' },
        { slug: 'declaracao-insuficiencia-recursos' },
        { slug: 'rg', legalResponsible: true },
        { slug: 'cpf', legalResponsible: true },
        { slug: 'rg', legalResponsible: false },
        { slug: 'cpf', legalResponsible: false },
        { slug: 'certidao-nascimento', legalResponsible: true },
        { slug: 'certidao-obito', legalResponsible: true },
        { slug: 'certidao-casamento', legalResponsible: true },
        { slug: 'certidao-casamento-divorcio', legalResponsible: true },
        { slug: 'certidao-uniao-estavel', legalResponsible: true },
        { slug: 'declaracao-separacao', legalResponsible: true },
        { slug: 'comprovante-tempo-posse' },
        { slug: 'comprovante-endereco' }
      ]

      const files = []

      const documents = landDocuments
        .filter(document => {
          const documentResident = document.residentDocuments.nodes[0]?.resident || {}
          let slugs = documentTypeSlugOrder.filter(item => item.slug === document.documentType.slug)
          if (slugs.some(slug => slug.legalResponsible !== undefined)) {
            slugs = slugs.filter(item => documentResident.legalResponsible === item.legalResponsible)
          }
          return slugs.length > 0
        })
        .sort((a, b) => {
          const aLegalResponsible = a.residentDocuments.nodes[0]?.resident?.legalResponsible
          const bLegalResponsible = b.residentDocuments.nodes[0]?.resident?.legalResponsible
          if (aLegalResponsible === bLegalResponsible) {
            return 0
          }
          return aLegalResponsible ? -1 : 1
        })
        .sort((a, b) => {
          const aIndex = documentTypeSlugOrder.findIndex(({ slug }) => slug === a.documentType.slug)
          const bIndex = documentTypeSlugOrder.findIndex(({ slug }) => slug === b.documentType.slug)
          return aIndex - bIndex
        })

      for (const document of documents) {
        // Logica para geração de PDF
        const pages = document.pages?.filter(page => !page.deleted) || []
        // Link do zapSign
        if (String(document.url || '').indexOf('zapsign') !== -1) {
          const url = await this.getSignedZapSignUrl(document, !!document.urlSigned)
          const slug = documentTypeSlugOrder.find(({ slug }) => slug === document.documentType.slug)
          files.push({ url, type: 'pdf', pages: slug.pages })
        } else {
          const hasImagePages = pages.some(page => page.type.startsWith('image/'))
          const nonImagePages = pages.filter(page => !page.type.startsWith('image/'))

          // Link para o relatório de impressão que serve apenas para paginas do tipo imagem
          if (hasImagePages) {
            const documentReport = this.$router.resolve({
              name: 'document-print',
              params: {
                projectId: this.selectedProject.id,
                documentId: document.id
              }
            })

            const url = this.getFullUrl(documentReport.href)
            files.push({ url })
          } else if (nonImagePages.length) {
            // signed link para pdfs que não são imagens
            for (const page of nonImagePages) {
              const url = await this.getSignedS3Url(page, `${document.name} - Página ${page.page}.pdf`)
              files.push({ url, type: 'pdf' })
            }
          }
        }
      }

      if (files.length) {
        // add croqui and memorial
        const landSketch = this.$router.resolve({
          name: 'land-sketch',
          params: {
            projectId: this.selectedProject.id,
            landId: land.id
          }
        })
        const landSketchUrl = this.getFullUrl(landSketch.href)
        files.push({ url: landSketchUrl })

        const landMemorial = this.$router.resolve({
          name: 'land-memorial',
          params: {
            projectId: this.selectedProject.id,
            landId: land.id
          }
        })
        const landMemorialhUrl = this.getFullUrl(landMemorial.href)
        files.push({ url: landMemorialhUrl })

        return {
          job: {
            jobBatchId,
            referenceId: land.id,
            type: 'PDF_GENERATION',
            status: 'CREATED',
            payload: {
              token: this.$authToken,
              projectId: this.selectedProject.id,
              landId: land.id,
              docTypeId: docTypeLandDossie.id,
              uuid: uuid(),
              files
            }
          }
        }
      }

      return null
    }
  }
}
